import React from 'react';
import '../../styles/cards.css';

export default function KPICard({ label, value, sub, delta, deltaDir, accent = 'kb', alert }) {
  return (
    <div className={`kc ${accent}${alert ? ' kc-alert' : ''}`}>
      <div className="klbl">{label}</div>
      <div className="kval">{value ?? '—'}</div>
      <div className="ksub">
        {sub}
        {delta && (
          <span className={`kdelta ${deltaDir === 'up' ? 'ku' : 'kd'}`}>{delta}</span>
        )}
      </div>
    </div>
  );
}
